import notScheduledImg from "../../../../../assets/images/notScheduled.png";

const NotScheduled = () => {
  return (
    <div className="relative w-full min-h-screen flex items-center justify-center py-4 px-4 sm:px-6 lg:px-12 bg-profile-bkg">
      <div className="personal-scroll-wrapper w-full max-w-[1400px] bg-bkg rounded-[30px] flex gap-6 overflow-hidden shadow-md">
        <div className="flex justify-center items-center w-full py-10">
          <img
            src={notScheduledImg}
            alt="scheduleNotStarted"
            className="w-[300px] h-[300px] lg:w-[500px] lg:h-[500px] object-cover"
          />
        </div>
      </div>
    </div>
  );
};

export default NotScheduled;
